import { LinkProps } from '@material-ui/core/Link';
import React from 'react';
import LinkRouter from '../../common/LinkRouter';

interface Props extends LinkProps {
    deckName: string;
    tag?: string;
    version?: string;
}

function FaroDeckLink(props: Props) {
    const { deckName, tag, version, ...other } = props;

    let identifierType;
    let identifier;
    if (version && !(version.startsWith('((') && version.endsWith('))'))) {
      identifierType = 'version';
      identifier = version;
    } else if (!!tag && !(tag.startsWith('((') && tag.endsWith('))'))) {
      identifierType = 'tag';
      identifier = tag;
    } else {
      identifierType = 'tag';
      identifier = 'latest'
    }

    return (
        <LinkRouter {...other} to={`/faro/decks/${deckName}?${identifierType}=${encodeURIComponent(identifier)}`}>{deckName}</LinkRouter>
    );
};

export default FaroDeckLink;